import { useState } from 'react'
import { useRequest, useView } from '@10000/react'
import { subscriptionBackground, useBackground, useShell, useStack } from '../../layout'
import { Box, H3, Button, SelectButtons } from '../../widgets'
import { SubscriptionSelect, PartnerPricingForm, PartnerPricing } from '../../subscription'
import { partner, single, isPartner, subscriptions, isFree } from '../../../lookups'
import { Company } from '../account'
import './Subscriptions.scss'

export const Subscriptions = ({ active, fromFreeSquiz }) => {
  const { subscription: { index } = {}, partnerRequest } = useView('tenant')
  const { push } = useStack()
  const request = useRequest('tenant')

  const [selectedSubscription, setSelectedSubscription] = useState((index !== undefined && !isFree({ index })) ? index : single[0].id)
  const [showPartner, setShowPartner] = useState(false)

  useBackground().set((mobile) => ({ active, fade: mobile, ...subscriptionBackground(mobile, false, !partnerRequest && showPartner) }))
  useShell({ active, mode: 'navigate' })

  const selectSubscription = () => {
    if(isPartner({ index: selectedSubscription }) && !partnerRequest) {
      setShowPartner(true)
    } else if(selectedSubscription !== undefined) {
      return request('subscriptionSelected', { index: selectedSubscription })
        .then(() => push(Company, { props: { fromFreeSquiz } }))
    }
  }

  const setSubscriptionType = index => {
    setShowPartner(index === 1)
    setSelectedSubscription(index === 0 ? single[0].id : partner[0].id)
  }

  return <Box className="subscription-container" fullWidth fullHeight column>
    <Box column className="subscription-content">
      <Box className="subscription-title">
        <H3 align="center">Choose your subscription</H3>
        <Box className="select-buttons-container">
          <SelectButtons
            size={16}
            fullWidth
            items={['All plans', 'Partners']}
            selectedIndex={showPartner ? 1 : 0}
            onClick={setSubscriptionType}
          />
        </Box>
      </Box>

      <Box className="subscription-options" column gap={32}>
        {showPartner
          ? partnerRequest
            ? <PartnerPricing onSubscriptionSelected={setSelectedSubscription} />
            : <PartnerPricingForm submitPadding="submit-top-padding" />
          : <SubscriptionSelect
              row
              onSubscriptionSelected={setSelectedSubscription}
              onPartnerChanged={setShowPartner}
            />
        }
      </Box>
    </Box>

    {(!showPartner || (showPartner && partnerRequest)) && (
      <Box className="submit-footer-container">
        <Button fullWidth onClick={selectSubscription} disabled={!subscriptions[selectedSubscription]?.price}>
          Next
        </Button>
      </Box>
    )}
  </Box>
}